import styled from 'styled-components';
import spacing from '../../../../helpers/spacing';

export const InfoWrapper = styled.div`
  margin-bottom: ${spacing(1)};
`;
